import { APIResponseType } from "../../types/generics/APIResponse.type";
import { createGetApiHook, createPostApiHook, tokenSourceFn } from "./apiHooks";
import axios from "axios";
import { API_BASE_URL } from "./axiosConfig";
import { string } from "yup";

const getAllBookings = (queryParams: Record<string, any> = {}): string => {
  const fullParams = {
    ...queryParams,
    offset: queryParams.offset ?? 0,
    limit: queryParams.limit ?? 1000,
  };

  const queryString = new URLSearchParams(fullParams).toString();
  return `/bookings?${queryString}`;
};

const invitePeople = ({ id }: { id: number }) => `/bookings/invite/${id}`;

export const useCreateBooking = createPostApiHook<{}, {}, APIResponseType<any>>(
  "/bookings",
  {
    isFormDataMethod: false,
  }
);

export const useGetBookings = createGetApiHook<APIResponseType<any>, any>(
  getAllBookings
);

export const useGetBookingById = createGetApiHook<
  APIResponseType<any>,
  { id: string }
>(({ id }) => `/bookings/${id}`);

export const getAllBookingsFn = async (talentId: string) => {
  try {
    const response = await axios.get(
      API_BASE_URL + "/bookings?offset=0&limit=1000",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "talent-id": talentId,
          Authorization: `Bearer ${tokenSourceFn()}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const useRespondBooking = createPostApiHook<
  {},
  {},
  APIResponseType<any>
>("/bookings/response", {
  isFormDataMethod: false,
});

export const respondBookingsFn = async (
  talentId: string,
  payload: Record<string, any>
) => {
  try {
    const response = await axios.post(
      API_BASE_URL + "/bookings/response",
      payload,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "talent-id": talentId,
          Authorization: `Bearer ${tokenSourceFn()}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const joinBookingCallFn = async (bookingId: string | number) => {
  try {
    const response = await axios.post(
      API_BASE_URL + `/bookings/join/${bookingId}`,
      { id: bookingId },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenSourceFn()}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const startBookingCallFn = async (
  talentId: string,
  bookingId: string | number
) => {
  try {
    const response = await axios.post(
      API_BASE_URL + `/bookings/start/${bookingId}`,
      { id: bookingId },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "talent-id": talentId,
          Authorization: `Bearer ${tokenSourceFn()}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const gtpMemberJoinCallFn = async (
  talentId: string,
  bookingId: string | number
) => {
  try {
    const response = await axios.post(
      API_BASE_URL + `/bookings/member-join/${bookingId}`,
      { id: bookingId },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "talent-id": talentId,
          Authorization: `Bearer ${tokenSourceFn()}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const endBookingCallFn = async (
  talentId: string,
  bookingId: string | number
) => {
  try {
    const response = await axios.post(
      API_BASE_URL + `/bookings/end/${bookingId}`,
      { id: bookingId },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "talent-id": talentId,
          Authorization: `Bearer ${tokenSourceFn()}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const useGetBookmarkedCards = createGetApiHook<
  APIResponseType<any>,
  any
>((queryParams) => {
  const query = new URLSearchParams(queryParams).toString();
  return `/taas-cards/bookmark${query ? `?${query}` : ""}`;
});

export const useGetAddedToDeckCards = createGetApiHook<
  APIResponseType<any>,
  any
>((queryParams) => {
  const query = new URLSearchParams(queryParams).toString();
  return `/taas-cards/deck${query ? `?${query}` : ""}`;
});

export const useAcceptGroupInvitation = createPostApiHook<
  { id: number; notification_id: number; status: string }, // ✅ Payload
  {}, // ✅ No URL/query parameters
  APIResponseType<any>
>("/bookings/group-session/accept", {
  isFormDataMethod: false,
});

export const useInvitePeople = createPostApiHook<
  { invites: number[] },
  { id: number },
  APIResponseType<any>
>(invitePeople, {
  isFormDataMethod: false,
});
